(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EgsFormController', EgsFormController);

    EgsFormController.$inject = ['AlertService',  'SoopkitchenUtils', 'EGSService', '$uibModalInstance'];

    function EgsFormController(AlertService, SoopkitchenUtils, EGSService, $uibModalInstance) {

        var vm = this;

        /**** Properties ****/
        vm.labelVal = "";
        vm.params = EGSService.createEGSParameters();
        vm.orbitFileNames = [];
        vm.nominalStartSpecifier = "";

        /**** Methods ****/
        vm.reset = reset;
        vm.clear = clear;
        vm.runEgs = runEgs;
        vm.removeDateRange = removeDateRange;
        vm.intervalsWrong = intervalsWrong;

        EGSService.loadOrbitFileNames(successLoadOrbitFiles, failureLoadOrbitFiles);


        function intervalsWrong() {
            var oneHasWrongInterval = false;

            for (var paramSection in vm.params) {
                if (vm.params.hasOwnProperty(paramSection)) {
                    for (var paramCounter in vm.params[paramSection]) {
                        if (vm.params[paramSection].hasOwnProperty(paramCounter)) {
                            var parameter = vm.params[paramSection][paramCounter];
                            if (parameter.dateRanges === true) {
                                for (var interval in parameter.value) {
                                    if (parameter.value[interval].endDate<parameter.value[interval].startDate) {
                                        parameter.opts[interval].wrongInterval = true;
                                        oneHasWrongInterval = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return oneHasWrongInterval;
        }

        function reset() {
            vm.labelVal = "";
            for (var i = 0; i < vm.params.length; i++) {
                EGSService.resetParamsInArray(vm.params[i]);
            }
            vm.selectedOrbitFileName = null;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function jobSubmittedSuccessfully(response) {
            SoopkitchenUtils.processResponse(response, "EGS Job submitted", "EGS Job submitted successfully with ID: " + response.data.id, function () {
                location.reload();
            });
        }

        function jobSubmittedFailure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function extractParameter(paramSection, egsParameters) {
            for (var paramCounter in vm.params[paramSection]) {
                if (vm.params[paramSection].hasOwnProperty(paramCounter)) {
                    var parameter = vm.params[paramSection][paramCounter];
                    if (parameter.dateRanges === true && parameter.valueText == null) {
                        egsParameters[parameter.id] = EGSService.getDateRangesFromObj(parameter.value);
                    } else if (parameter.dateRanges === true && parameter.valueText != null) {
                        egsParameters[parameter.id] = EGSService.getDateRangesFromString(parameter.valueText.value);
                    } else {
                        egsParameters[parameter.id] = parameter.value;
                    }
                }
            }
        }

        function runEgs() {
            var egsJob = {};
            var egsParameters = {};
            for (var paramSection in vm.params) {
                if (vm.params.hasOwnProperty(paramSection)) {
                    extractParameter(paramSection, egsParameters);
                }
            }
            egsJob.egsParameters = egsParameters;
            egsJob.orbitFilename = vm.selectedOrbitFileName ;
            egsJob.label = vm.labelVal;
            egsJob.nominalStartSpecifier =  vm.nominalStartSpecifier;
            egsJob.successURL = '<<to be filled in server>>';
            egsJob.failureURL = '<<to be filled in server>>';
            EGSService.runEGS(egsJob, jobSubmittedSuccessfully, jobSubmittedFailure);
            $uibModalInstance.dismiss('cancel');
        }

        function removeDateRange(dateRangeParam, valueIndex) {
            var length = dateRangeParam.value.length;
            if (valueIndex < length - 1) {
                for (var i = valueIndex + 1; i < length; i++) {
                    dateRangeParam.opts[i] = EGSService.getPickerOpts(dateRangeParam, i - 1, dateRangeParam.opts[i].startDate, dateRangeParam.opts[i].endDate);
                }
                SoopkitchenUtils.removeIndexFromArray(dateRangeParam.opts, valueIndex);
                SoopkitchenUtils.removeIndexFromArray(dateRangeParam.value, valueIndex);
            }
        }

        function successLoadOrbitFiles(response) {
            vm.orbitFileNames = response.data;
            if (vm.orbitFileNames.length === 0) {
                SoopkitchenUtils.prettyError(response);
            } else {
                reset();
            }

        }

        function failureLoadOrbitFiles(response) {
            if (response.status !== 500) {
                SoopkitchenUtils.prettyError(response, function () {
                    $scope.$apply();
                });
            } else {
                AlertService.error("Unable to retrieve the Orbit Files.");
            }

        }

    }
})();
